import { render, staticRenderFns } from "./VirtualStopsForm.vue?vue&type=template&id=4f7fc104"
import script from "./VirtualStopsForm.vue?vue&type=script&lang=js"
export * from "./VirtualStopsForm.vue?vue&type=script&lang=js"
import style0 from "./VirtualStopsForm.vue?vue&type=style&index=0&id=4f7fc104&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports